/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let expandIsExpandedValueData = fromData.useDataValue({ viewPath,
context: 'expand',
path: 'is_expanded',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(expandIsExpandedValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}